'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const BulletCheckIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="BulletCheckIcon">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_278_68420)">
          <path
            d="M12 4.66666L7.74667 10.44C7.69314 10.5129 7.62534 10.5741 7.54741 10.6199C7.46948 10.6658 7.38303 10.6953 7.29333 10.7067C7.20486 10.718 7.11503 10.7114 7.02914 10.6873C6.94326 10.6633 6.86307 10.6223 6.79333 10.5667L4 8.33332"
            stroke="#5073C3"
            strokeWidth="0.666667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.333344 8.00001C0.333343 9.00681 0.531648 10.0038 0.916934 10.9339C1.30222 11.8641 1.86694 12.7092 2.57886 13.4212C3.29077 14.1331 4.13594 14.6978 5.0661 15.0831C5.99627 15.4684 6.99321 15.6667 8.00001 15.6667C9.00681 15.6667 10.0038 15.4684 10.9339 15.0831C11.8641 14.6978 12.7092 14.1331 13.4212 13.4212C14.1331 12.7092 14.6978 11.8641 15.0831 10.9339C15.4684 10.0038 15.6667 9.00681 15.6667 8.00001C15.6667 6.99321 15.4684 5.99627 15.0831 5.0661C14.6978 4.13594 14.1331 3.29077 13.4212 2.57886C12.7092 1.86694 11.8641 1.30222 10.9339 0.916934C10.0038 0.531648 9.00681 0.333344 8.00001 0.333344C6.99321 0.333344 5.99627 0.531648 5.0661 0.916934C4.13594 1.30222 3.29077 1.86694 2.57886 2.57886C1.86694 3.29077 1.30222 4.13594 0.916934 5.0661C0.531648 5.99627 0.333343 6.99321 0.333344 8.00001Z"
            stroke="#5073C3"
            strokeWidth="0.666667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

BulletCheckIcon.propTypes = {
  sx: PropTypes.object
}
